export default {
  data () {
    return {
      colCenters: []
    }
  },
  methods: {
    getBranchWiseCollectionCenter (branch, withChangeFilter) {
      this.form.branch_id = branch.id
      this.colCenters = []
      this.collectionCenter = {}
      this.form.collection_center_id = ''
      this.$axios.get('collectioncenter?all=all&status=active&branch_id=' + branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.colCenters = data.data
          _.forEach(this.colCenters, function (item, key) {
            this.colCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
          if (withChangeFilter === true) {
            this.changeFilter()
          }
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/BranchWiseCollectionCenterData.js